import {PermissionEditor} from '../../users/components/permissions/PermissionEditor'

// A single user's permissions (Overview → Permissions tab). Reuses the shared
// subject-focused editor locked to this user (Inherit / Allow / Deny overrides).
export const UserPermissionsTab = ({userId, userName}: {userId: number | string; userName?: string}) => (
  <div className='card'>
    <div className='card-header'>
      <h3 className='card-title mb-0'>Permissions{userName ? ` — ${userName}` : ''}</h3>
    </div>
    <div className='card-body'>
      <PermissionEditor lockedUser={{id: String(userId), name: userName || `User ${userId}`}} />
    </div>
  </div>
)
